<template>
  <div id="container">
    <div class="wrapper">
      <p class="welcome">{{ $t('welcomeTo') }}</p>
      <img src="../assets/static/icons/expar_logo_new.svg" alt="expar_logo" />
      <span class="logo-text">
        expar
      </span>
    </div>
    <!-- <div class="homepageText" v-if="!loggedIn">
      {{ $t('touseplatform') }}
      <router-link class="underline"  :to="'/' + 'login/' + $i18n.locale" >{{ $t('login1') }}</router-link>
    </div> -->
    <br />
    <a
      v-if="env === 'production'"
      href="//expar.si"
      data-qa="homaPageButton"
      class="info-btn2"
      >{{ $t('homepage') }}</a
    >
    <a
      v-else
      href="//demo.expar.si"
      data-qa="homaPageButton"
      class="info-btn2"
      >{{ $t('homepage') }}</a
    >
  </div>
</template>

<script>
import { authComputed } from '../store/helpers.js'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('logout')
    }
  },
  data() {
    return {
      env: process.env.NODE_ENV
    }
  },
  computed: {
    ...authComputed
  }
}
</script>

<style lang="scss" scoped>
body,
html {
  height: 100%;
  margin: 0;
}

#container {
  // background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
  //   url('../assets/static/images/hero.jpg');
  background: linear-gradient(
    193deg,
    rgba(12, 46, 68, 1) 0%,
    rgba(61, 88, 105, 1) 28%,
    rgba(96, 93, 108, 1) 64%,
    rgba(251, 115, 119, 1) 100%
  );
  // height: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  text-align: center;
}

.underline {
  text-decoration: underline;
}

.wrapper {
  padding-top: 100px;
}

img {
  margin-top: 4em;
  width: 8rem;
}

span {
  font-family: 'Nasalization', Helvetica, Arial;
  color: var(--white);
  font-size: 7rem;
  letter-spacing: 2px;
  font-weight: 500;
  margin-left: 8px;
}

.homepageText {
  color: var(--bright);
}

.logo-text {
  vertical-align: middle;
  display: inherit;
  margin: auto;
}

.welcome {
  color: var(--white);
  font-size: 2rem;
  margin-bottom: 2rem;
  font-weight: 200;
}

.info-btn2 {
  color: #fff;
  background: var(--primary);
  text-decoration: none !important;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.info-btn2:hover {
  background: #0c4f60;
}

path {
  stroke: #fff;
  fill: #fff;
  stroke-dasharray: 1800;
  opacity: 10;
  animation: animate 3s cubic-bezier(0, 0.23, 1, 0.1);
}

@keyframes animate {
  0% {
    opacity: 0;
    fill: none;
    stroke-dashoffset: 1800;
  }
  30% {
    opacity: 10;
    fill: none;
    stroke-dashoffset: 1800;
  }
  90% {
    fill: rgba(245, 255, 255, 0);
  }
  100% {
    opacity: 10;
    fill: rgba(255, 255, 255, 1);
    stroke-dashoffset: 0;
  }
}

/* ----  Responsiveness   ----  */
@media (max-width: 500px) {
  .info-btn {
    letter-spacing: 1px;
    padding: 5px 5px;
  }
  .wrapper {
    padding-top: 100px;
  }
  img {
    margin-top: 3em;
  }
  span {
    font-size: 3.5rem;
    letter-spacing: 1px;
    margin-top: 10rem;
    margin-left: 3px;
  }
}

/* SMARTPHONES LANDSCAPE */
@media only screen and (min-device-width: 480px) and (max-device-width: 820px) and (orientation: landscape) {
  span {
    font-size: 2rem;
    letter-spacing: 1px;
    padding: 0;
  }
  img {
    margin-top: 0.3em;
    width: 5rem;
  }
  .wrapper {
    padding-top: 50px;
  }
}

//iPhone 5 //
@media only screen and (min-device-width: 320px) and (max-device-width: 359px) and (orientation: portrait) {
}

@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  img {
    width: 3rem;
  }
}
</style>
